"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSpaceFunction = exports.SPACE_FUNCTION_CHOICES = exports.SPACE_FUNCTION_DISPLAY_NAMES = void 0;
var lib_api_types_1 = require("@densityco/lib-api-types");
exports.SPACE_FUNCTION_DISPLAY_NAMES = (_a = {},
    _a[lib_api_types_1.CoreSpaceFunction.BREAK_ROOM] = 'Break Room',
    _a[lib_api_types_1.CoreSpaceFunction.CAFE] = 'Cafe',
    _a[lib_api_types_1.CoreSpaceFunction.COLLABORATION] = 'Collaboration Room',
    _a[lib_api_types_1.CoreSpaceFunction.CONFERENCE_ROOM] = 'Conference Room',
    _a[lib_api_types_1.CoreSpaceFunction.DINING_AREA] = 'Dining Area',
    _a[lib_api_types_1.CoreSpaceFunction.EVENT_SPACE] = 'Event Space',
    _a[lib_api_types_1.CoreSpaceFunction.FOCUS_QUIET] = 'Focus / Quiet Room',
    _a[lib_api_types_1.CoreSpaceFunction.GYM] = 'Gym',
    _a[lib_api_types_1.CoreSpaceFunction.KITCHEN] = 'Kitchen',
    _a[lib_api_types_1.CoreSpaceFunction.LAB] = 'Lab',
    _a[lib_api_types_1.CoreSpaceFunction.LIBRARY] = 'Library',
    _a[lib_api_types_1.CoreSpaceFunction.LOUNGE] = 'Lounge',
    _a[lib_api_types_1.CoreSpaceFunction.MEETING_ROOM] = 'Meeting Room',
    _a[lib_api_types_1.CoreSpaceFunction.OFFICE] = 'Office',
    _a[lib_api_types_1.CoreSpaceFunction.PHONE_BOOTH] = 'Phone Booth',
    _a[lib_api_types_1.CoreSpaceFunction.PLACE_OF_WORSHIP] = 'Place of Worship',
    _a[lib_api_types_1.CoreSpaceFunction.RECEPTION] = 'Reception',
    _a[lib_api_types_1.CoreSpaceFunction.RESTROOM] = 'Restroom',
    _a[lib_api_types_1.CoreSpaceFunction.RETAIL] = 'Retail',
    _a[lib_api_types_1.CoreSpaceFunction.THEATER] = 'Theater',
    _a[lib_api_types_1.CoreSpaceFunction.WELLNESS_ROOM] = 'Wellness Room',
    _a);
exports.SPACE_FUNCTION_CHOICES = Object.keys(exports.SPACE_FUNCTION_DISPLAY_NAMES).map(function (id) { return ({ id: id, label: exports.SPACE_FUNCTION_DISPLAY_NAMES[id] }); });
exports.SPACE_FUNCTION_CHOICES.push({ id: null, label: 'Other' });
function formatSpaceFunction(spaceFunction) {
    return exports.SPACE_FUNCTION_DISPLAY_NAMES[spaceFunction] || spaceFunction || 'Other';
}
exports.formatSpaceFunction = formatSpaceFunction;
//# sourceMappingURL=index.js.map